<template>
  <div class="upload-container">
    <div>
      <p>
        Die hochzuladene Datei (Format: .xslx) muss folgende Spalten enthalten:
      </p>
      <ul>
        <li>{{ new Date().getFullYear() }} Proposed Annual Revenue Target</li>
        <li>{{ new Date().getFullYear() }} Proposed Q1 Target</li>
        <li>{{ new Date().getFullYear() }} Proposed Q2 Target</li>
        <li>{{ new Date().getFullYear() }} Proposed Q3 Target</li>
        <li>{{ new Date().getFullYear() }} Proposed Q4 Target</li>
        <li>Vertriebler</li>
        <li>Reseller</li>
        <li>Kundennummer</li>
      </ul>
      <p>
        Die Spalten müssen mit exakt diesen Namen bezeichnet sein. Die <br />
        Vertriebler müssen mit Vor- und Nachnamen ausgeschrieben sein.
      </p>
      <p>
        Eine Beispiel-Datei kann
        <a href="/Vizrt_Upload_Beispieldatei.xlsx" download>hier</a>
        heruntergeladen werden.
      </p>
    </div>
    <div class="label-container">
      <label for="vizrt-list-upload" class="label">
        <font-awesome-icon :icon="['fas', 'file-import']" />&nbsp;<span
          >Datei auswählen</span
        >
        <input
          type="file"
          accept=".xlsx"
          id="vizrt-list-upload"
          v-on:change="readFile($event)"
        />
      </label>
    </div>
    <p v-if="fileName" class="filename">{{ fileName }}</p>
    <div class="center">
      <b-button
        variant="success"
        class="btn"
        :disabled="!fileName"
        v-on:click="uploadData()"
      >
        <span v-if="!loading">Hochladen</span>
        <span v-else>
          <b-spinner variant="white" type="grow"></b-spinner>
        </span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { doc, setDoc } from "firebase/firestore";
import { firestore } from "../../firebase";
import * as XLSX from "xlsx";
export default {
  name: "VizrtOverviewView",
  components: {},
  methods: {
    closeModal() {
      this.$emit("close");
    },
    async readFile(event) {
      this.fileName = event.target.files[0].name;
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(event.target.files[0]);
      fileReader.onload = (e) => {
        const bufferArray = e?.target.result;
        const wb = XLSX.read(bufferArray, { type: "buffer" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        this.data = XLSX.utils.sheet_to_json(ws);
        console.log(this.data);
      };
    },
    async uploadData() {
      let vertrieblerArr = [];
      this.data.forEach((item) => {
        if (
          item.Vertriebler &&
          vertrieblerArr.indexOf(
            item.Vertriebler.trim().replaceAll(/\s/g, "_")
          ) === -1
        ) {
          vertrieblerArr.push(item.Vertriebler);
        }
      });
      vertrieblerArr = vertrieblerArr.map((item) => {
        return {
          vertriebler: item.trim().replaceAll(/\s/g, "_"),
          kunden: [],
        };
      });
      this.data.forEach((entry) => {
        if (entry.Vertriebler) {
          for (let i = 0; i < vertrieblerArr.length; i++) {
            if (
              entry.Vertriebler.trim().replaceAll(/\s/g, "_") ===
                vertrieblerArr[i].vertriebler.trim().replaceAll(/\s/g, "_") &&
              entry.Kundennummer
            ) {
              vertrieblerArr[i].kunden.push({
                kundennummern: [entry.Kundennummer],
                name: entry.Reseller.trim().replaceAll(/\s/g, "_"),
              });
            }
          }
        }
      });
      try {
        this.loading = true;
        for await (const item of this.data) {
          if (item.Vertriebler) {
            await setDoc(
              doc(
                firestore,
                "vizrtReseller",
                item.Reseller.trim().replaceAll(/\s/g, "_")
              ),
              item
            );
          }
        }
        for await (const item of vertrieblerArr) {
          await setDoc(
            doc(firestore, "vizrtVertriebler", item.vertriebler),
            item
          );
        }
        this.$emit("finished");
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
        this.fileName = "";
        this.closeModal();
      }
    },
  },
  data() {
    return {
      fileName: "",
      data: undefined,
      loading: false,
    };
  },
};
</script>

<style scoped>
.upload-container {
  background-color: #fff;
  padding: 32px;
  border-radius: 4px;
}
.label-container {
  display: flex;
  justify-content: center;
}
.label {
  width: 300px;
  cursor: pointer;
  text-align: center;
  border: 1px solid #4089c9;
  border-radius: 4px;
  background-color: #4089c9;
  color: #fff;
  padding: 6px;
  transition: all 350ms;
}
.label:hover {
  background-color: #fff;
  color: #4089c9;
}
#vizrt-list-upload {
  display: none;
}
.filename {
  text-align: center;
}
.center {
  display: flex;
  justify-content: center;
  margin-top: 8px;
  gap: 32px;
}
.btn {
  width: 300px;
}
</style>
